import { render, staticRenderFns } from "./showmall.vue?vue&type=template&id=67b4b407&scoped=true"
import script from "./showmall.vue?vue&type=script&lang=js"
export * from "./showmall.vue?vue&type=script&lang=js"
import style0 from "./showmall.vue?vue&type=style&index=0&id=67b4b407&prod&scoped=true&lang=css"
import style1 from "./showmall.vue?vue&type=style&index=1&id=67b4b407&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4b407",
  null
  
)

export default component.exports